import { css } from 'lit';
import resetScss from '@components/css/lib/reset.scss';
import sharedScss from '@components/css/shared.scss';
import { CSSResultArray, LitElement, css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ConfigWZRT } from '@/config/ConfigWZRT';
import { WZRT_TRAINING_MATERIALS_URL } from '@/config/ConfigCARSx';

@customElement('work-zone-training-link')
export default class WorkZoneTrainingLink extends LitElement {
	public static override get styles(): CSSResultArray {
		return [
			resetScss,
			sharedScss,
			css`
				:host {
					display: flex;
				}
				a {
					flex: 1;
					align-self: center;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: var(--ggutter) calc(var(--ggutter) * 1.5);
					border-radius: 3px;
					font-weight: bolder;
					font-size: 1.6rem;
					line-height: 1.6rem;
					text-transform: uppercase;
					color: #000;
					background: rgb(116, 165, 78);
					height: auto;
				}
				a:hover {
					background: rgb(165, 201, 130);
				}
			`,
		];
	}

	override render() {
		const { label } = ConfigWZRT.trainingMaterials;

		if (WZRT_TRAINING_MATERIALS_URL == null) {
			return nothing;
		}

		return html`<a href="${WZRT_TRAINING_MATERIALS_URL}">${label}</a>`;
	}
}
